import { FiInfo } from "react-icons/fi";

export function PrototypeBanner() {
  return (
    <div className="bg-gray-50 border-b border-gray-200 py-3 px-4">
      <div className="flex items-center justify-center gap-3 text-gray-500">
        <FiInfo className="text-lg flex-shrink-0" />
        <p className="text-sm">
          This is a pilot built as part of OGP&apos;s{" "}
          <a
            href="https://hack.gov.sg/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-700"
          >
            Hack for Public Good
          </a>
          , in collaboration with MOE.
        </p>
      </div>
    </div>
  );
}
